define('controllers/Podio.Controllers.UnsupportedBrowser',['require','jquery','jquery.cookie','lib/backbone/Backbone.PodioController','views/lib/Podio.Views.UnsupportedBrowser','lib/Podio.Config','lib/Podio.Utils','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.UI.Modal'],function(require) {

  var $ = require('jquery');
  require('jquery.cookie');

  var PodioController = require('lib/backbone/Backbone.PodioController');
  var UnsupportedBrowserView = require('views/lib/Podio.Views.UnsupportedBrowser');
  var config = require('lib/Podio.Config');
  var utils = require('lib/Podio.Utils');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var modal = require('lib/Podio.UI.Modal');

  var UnsupportedBrowser = PodioController.extend({

    initialize: function() {

      this._super();

      this.bindAll('onUnsupportedBrowsersLoaded');
      this.cookieName = '_podio-unsupported-browser-warning-hide';

      if (!config.isBrowserDeprecated) {
        return false;
      }

      if ($.cookie(this.cookieName) === 'true') {
        return false;
      }

      if (!utils.loggedIn()) {
        return false;
      }

      this.eventBus.bind('viewUnsupportedBrowser:finishedTrigger', this.onFinishedTrigger, this);
      this.eventBus.bind('viewChromeFrameInstaller:finishedTrigger', this.onFinishedTrigger, this);

      var req = transport.getJSON( routes.unsupported_browsers_list_path() );
      req.done(this.onUnsupportedBrowsersLoaded);

    },

    onUnsupportedBrowsersLoaded: function(responseData) {
      var view = new UnsupportedBrowserView({
        eventBus: this.eventBus,
        browsers: responseData.data.browsers
      });

      view.render();
    },

    onFinishedTrigger: function() {
      modal.hide();
      $.cookie(this.cookieName, 'true', {
        expires: 365,
        path: '/',
        domain: config.base_domain
      });
    }

  });

  new UnsupportedBrowser();

});

